import { render } from "./ListWishView.vue?vue&type=template&id=35c38ad0"
import script from "./ListWishView.vue?vue&type=script&lang=js"
export * from "./ListWishView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__